'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _reactReveal = require('react-reveal');

var _reactReveal2 = _interopRequireDefault(_reactReveal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars
var Home = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home() {
    (0, _classCallCheck3.default)(this, Home);
    return (0, _possibleConstructorReturn3.default)(this, (Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).apply(this, arguments));
  }

  (0, _createClass3.default)(Home, [{
    key: 'render',
    value: function render() {
      var styles = require('./Home.scss');
      // require the logo image both from client and server
      var boyImage = require('./boy.png');
      var moduleImg2 = require('./moduleImg2.png');
      var moduleImg3 = require('./moduleImg3.png');
      var tkcpLogo = require('../About/Assets/TKCP-Logo.jpg');

      return _react2.default.createElement(
        'div',
        { className: styles.home },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Home' }),
        _react2.default.createElement(
          'div',
          { className: styles.header },
          _react2.default.createElement(
            'div',
            { className: styles.textVerticalCenter + ' ' + styles.animated3s + ' ' + styles.fadeIn },
            _react2.default.createElement(
              'h1',
              null,
              'Reboot Kids'
            ),
            _react2.default.createElement('hr', { className: styles.small }),
            _react2.default.createElement(
              'h3',
              null,
              _config2.default.app.description
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.section },
          _react2.default.createElement(
            ReactBootstrap.Grid,
            null,
            _react2.default.createElement(
              ReactBootstrap.Row,
              null,
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 8 },
                _react2.default.createElement(
                  'h1',
                  null,
                  'What is Reboot Kids?'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'Reboot Kids'
                  ),
                  ' is a behaviour-change programme designed to help parents and caregivers of cancer surviving children to guide their children into healthy eating habits.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'You can work through the series of modules at your own pace so your family can move towards a ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'healthier future.'
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Whatever your goal is with undertaking the Reboot Kids Programme, we are confident that you will achieve it, or be well on your way to achieving it, by the end of the programme. During each module it is important to think about what changes you want to introduce to your child and family environment and the strategies you will use to bring about these changes, in order to reach your goal. The programme will support you in making these decision.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'We wish you all the best as you begin your ',
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Reboot Kids journey!'
                  )
                )
              ),
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 4 },
                _react2.default.createElement(
                  ReactBootstrap.Row,
                  null,
                  _react2.default.createElement(
                    _reactReveal2.default,
                    { effect: styles.animated2s + ' ' + styles.fadeIn },
                    _react2.default.createElement(ReactBootstrap.Image, { className: 'center-block', src: boyImage, responsive: true })
                  )
                ),
                _react2.default.createElement(
                  ReactBootstrap.Row,
                  null,
                  _react2.default.createElement(
                    ReactBootstrap.Col,
                    { xs: 8, md: 8, className: 'center-block' },
                    _react2.default.createElement(
                      'p',
                      { className: styles.textCenter },
                      _react2.default.createElement(
                        'strong',
                        null,
                        'The Reboot Kids programme is funded and proudly supported by The Kids With Cancer Foundation'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Col,
                    { xs: 2, md: 2 },
                    _react2.default.createElement(
                      _reactReveal2.default,
                      { effect: styles.animated2s + ' ' + styles.fadeIn },
                      _react2.default.createElement(
                        'a',
                        { href: 'https://www.thekidscancerproject.org.au', target: '_blank' },
                        _react2.default.createElement(ReactBootstrap.Image, { className: styles.logoSize, src: tkcpLogo })
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.section + ' ' + styles.modulesSection },
          _react2.default.createElement(
            ReactBootstrap.Grid,
            null,
            _react2.default.createElement(
              ReactBootstrap.Row,
              { className: styles.textCenter },
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 12, sm: 12, lg: 12 },
                _react2.default.createElement(
                  _reactReveal2.default,
                  { effect: styles.animated2s + ' ' + styles.fadeIn },
                  _react2.default.createElement(
                    'h1',
                    null,
                    'Modules'
                  ),
                  _react2.default.createElement('hr', { className: styles.tiny }),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Complete 4 modules at your own pace!'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'These core modules will lead you and your child to a healthier future.'
                  )
                )
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer40 }),
            _react2.default.createElement(
              ReactBootstrap.Row,
              null,
              _react2.default.createElement(
                'div',
                { className: styles.textCenter },
                _react2.default.createElement(
                  _reactReveal2.default,
                  { effect: styles.animated2s + ' ' + styles.fadeIn },
                  _react2.default.createElement(
                    ReactBootstrap.Col,
                    { md: 3, sm: 6, xs: 6, lg: 3 },
                    _react2.default.createElement('i', { className: 'fa fa-4x fa-thumbs-up' }),
                    _react2.default.createElement(
                      'h4',
                      null,
                      'Clinically approved'
                    ),
                    _react2.default.createElement(
                      'p',
                      { className: styles.subtitle },
                      'Crafted by clinicians.'
                    )
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Col,
                    { md: 3, sm: 6, xs: 6, lg: 3 },
                    _react2.default.createElement('i', { className: 'fa fa-4x fa-trophy' }),
                    _react2.default.createElement(
                      'h4',
                      null,
                      'Effective'
                    ),
                    _react2.default.createElement(
                      'p',
                      { className: styles.subtitle },
                      'Road to recovery.'
                    )
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Col,
                    { md: 3, sm: 6, xs: 6, lg: 3 },
                    _react2.default.createElement('i', { className: 'fa fa-4x fa-universal-access' }),
                    _react2.default.createElement(
                      'h4',
                      null,
                      'Easy to use'
                    ),
                    _react2.default.createElement(
                      'p',
                      { className: styles.subtitle },
                      'Intuitive, sleek interface.'
                    )
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Col,
                    { md: 3, sm: 6, xs: 6, lg: 3 },
                    _react2.default.createElement('i', { className: 'fa fa-4x fa-heart' }),
                    _react2.default.createElement(
                      'h4',
                      null,
                      'Made with care'
                    ),
                    _react2.default.createElement(
                      'p',
                      { className: styles.subtitle },
                      'Made with thought.'
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.section },
          _react2.default.createElement(
            ReactBootstrap.Grid,
            null,
            _react2.default.createElement(
              ReactBootstrap.Row,
              null,
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 4 },
                _react2.default.createElement(
                  ReactBootstrap.Row,
                  null,
                  _react2.default.createElement(
                    _reactReveal2.default,
                    { effect: styles.animated2s + ' ' + styles.fadeIn },
                    _react2.default.createElement(ReactBootstrap.Image, { className: 'center-block', src: moduleImg3, responsive: true })
                  )
                )
              ),
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 8 },
                _react2.default.createElement(
                  'h1',
                  { className: styles.textCenter },
                  'My Goals'
                ),
                _react2.default.createElement('hr', { className: styles.small }),
                _react2.default.createElement(
                  'ol',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Keep track of your goals'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Set new goals'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Review previous goals'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Get into healthy habits'
                    )
                  )
                ),
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 12 },
                  _react2.default.createElement(
                    'p',
                    null,
                    'We know it\'s hard to change, but we\'ll help you along the way.'
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.section + ' ' + styles.recipesSection },
          _react2.default.createElement(
            ReactBootstrap.Grid,
            null,
            _react2.default.createElement(
              ReactBootstrap.Row,
              { className: styles.textCenter },
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 12, sm: 12, lg: 12 },
                _react2.default.createElement(
                  _reactReveal2.default,
                  { effect: styles.animated2s + ' ' + styles.fadeIn },
                  _react2.default.createElement(
                    'h1',
                    null,
                    'Recipes'
                  ),
                  _react2.default.createElement('hr', { className: styles.tiny }),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Unsure of what foods your child should be eating?'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'We\'ve got healthy recipes, you and your child can make!'
                  )
                )
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer40 }),
            _react2.default.createElement(ReactBootstrap.Row, null)
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.section },
          _react2.default.createElement(
            ReactBootstrap.Grid,
            null,
            _react2.default.createElement(
              ReactBootstrap.Row,
              null,
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 8 },
                _react2.default.createElement(
                  'h1',
                  null,
                  'Resources'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Additional resources, just in case you\'d like to learn more.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Just in case you\'d like to learn more than what the modules offer, we have additional information ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'curated by clinicians from the Sydney Children\'s Hospital'
                  ),
                  ' which you can directly access.'
                )
              ),
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 4 },
                _react2.default.createElement(
                  ReactBootstrap.Row,
                  null,
                  _react2.default.createElement(
                    _reactReveal2.default,
                    { effect: styles.animated2s + ' ' + styles.fadeIn },
                    _react2.default.createElement(ReactBootstrap.Image, { className: 'center-block', src: moduleImg2, responsive: true })
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.footer },
          _react2.default.createElement(
            ReactBootstrap.Grid,
            null,
            _react2.default.createElement(
              ReactBootstrap.Row,
              null,
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 12, className: styles.textCenter },
                _react2.default.createElement(
                  'p',
                  null,
                  'Copyright \xA9 Reboot Kids 2019, Sydney Children\'s Hospital'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Home;
}(_react.Component);

exports.default = Home;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.js
// module id = 1273
// module chunks = 0